export enum ChatSource {
    PATIENT = 'PATIENT',
    DOCTOR = 'DOCTOR',
}
